var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticStyle:{"width":"100%"}},[_c('canvas',{ref:"canvas",style:(_vm.canvasStyle),attrs:{"resize":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }